// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"4e36ffb1","353":"0cca62a0"}[chunkId] + ".chunk.css";
};